export interface ProductCarpetSpec {
  id: string;
  productId: string;
  colourId: string;
  colourKey: string;
  colourDescription: string;
  key: string;
  width: number;
  kgsPerMtr2: number;
  stdRollLength: number;
  aveRollLength: number;
  smallestReusable: number;
  acceptableWastage: number;
  conversionFactor: number;
  verticalPatternRepeat: string;
  horizontalPatternRepeat: string;
  patternMatch: string;
  reMeasureLevel: number;
  careInstructions: string;
  composition: string;
  comments: string;
}
